import { render, staticRenderFns } from "./_SolutionForm.vue?vue&type=template&id=24dfe388&scoped=true&"
import script from "./_SolutionForm.vue?vue&type=script&lang=ts&"
export * from "./_SolutionForm.vue?vue&type=script&lang=ts&"
import style0 from "./_SolutionForm.vue?vue&type=style&index=0&id=24dfe388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfe388",
  null
  
)

export default component.exports